import MoleculeBase from './MoleculeBase';

import { getInstance } from '../initialiser';

export default class MoleculeMini extends MoleculeBase {
  static fromSmarts(smarts: string): MoleculeMini {
    const {
      exports: { get_qmol },
    } = getInstance();

    return new MoleculeMini(get_qmol(smarts));
  }

  static fromSmiles(smiles: string): MoleculeMini {
    const {
      exports: { get_mol },
    } = getInstance();

    return new MoleculeMini(get_mol(smiles));
  }
}
